/*
  This component handles promise and does not call callbacks after component unmounts.
*/
import { useEffect, useRef } from 'react'

const emptyFn = () => {}

const PromiseHandler = props => {
  const { promise, then: onThen, catch: onCatch = emptyFn, finally: onFinally = emptyFn } = props
  const isMounted = useRef(false)

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    let shouldBeResolved = true

    const onPromiseThen = data => {
      if (isMounted.current && shouldBeResolved) {
        onThen(data)
      }
    }

    const onPromiseCatch = error => {
      if (isMounted.current && shouldBeResolved) {
        onCatch(error)
      }
    }

    const onPromiseFinally = () => {
      if (isMounted.current && shouldBeResolved) {
        onFinally()
      }
    }

    if (promise) {
      promise.then(onPromiseThen).catch(onPromiseCatch).finally(onPromiseFinally)
    }

    return () => {
      shouldBeResolved = false
    }
  }, [onCatch, onFinally, onThen, promise])

  return null
}

export default PromiseHandler
